import { render, staticRenderFns } from "./LeaveRecordList.vue?vue&type=template&id=7b46c61a&scoped=true"
import script from "./LeaveRecordList.vue?vue&type=script&lang=js"
export * from "./LeaveRecordList.vue?vue&type=script&lang=js"
import style0 from "./LeaveRecordList.vue?vue&type=style&index=0&id=7b46c61a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b46c61a",
  null
  
)

export default component.exports